module.exports = __webpack_public_path__ + "static/img/noorder.b96499ac.png";